<!-- ITP-E-173-06. Nothing flagged at all after the nightly run: the whole band is this one line. -->
<p *ngIf="allClear" data-testid="attention-all-clear" class="attention-all-clear">
  <i class="fa-regular fa-circle-check" aria-hidden="true"></i> Nothing needs attention
</p>
<section *ngIf="!allClear" data-testid="attention" class="attention">
  <header class="attention__head">
    <div class="attention__heading">
      <h3 data-testid="attention-title" class="attention__title">Needs attention</h3>
      <p *ngIf="attention?.AsOf" data-testid="attention-summary" class="attention__summary">{{ summaryText }}</p>
    </div>
    <div *ngIf="attention?.AsOf" class="attention__aside">
      <span data-testid="attention-tiers" class="attention-tiers" aria-label="Health tiers">
        <span class="attention-tiers__item" data-tier="critical">Critical &lt; 40</span>
        <span class="attention-tiers__item" data-tier="warning">Warning 40–65</span>
        <span class="attention-tiers__item" data-tier="watch">Watch 65–80</span>
      </span>
      <button mat-stroked-button type="button" class="attention__export adb-natural-width"
              data-testid="attention-export" data-screenshot-ignore
              [disabled]="exporting" (click)="exportExcel()">
        <i class="fa-regular fa-file-excel"></i> {{ exporting ? 'Exporting…' : 'Export to Excel' }}
      </button>
    </div>
  </header>
  <div *ngIf="attention?.AsOf" data-testid="attention-cards" class="attention__cards">
    <article data-testid="card-renewal" class="attention-card" data-tone="critical">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-file-contract" aria-hidden="true"></i>
        <h4 class="attention-card__title">Renewals at risk</h4>
      </header>
      <ng-container *ngIf="scope !== 'NonClients'; else renewalNa">
        <p class="attention-card__figure">
          <span data-testid="card-renewal-value" class="attention-card__value">{{ kindCount('renewal') | number }}</span>
          <span data-testid="card-renewal-unit" class="attention-card__unit">{{ arrUnit('renewal') }}</span>
        </p>
        <p data-testid="card-renewal-reason" class="attention-card__reason">
          <ng-container *ngIf="topOf('renewal') as top; else noRenewal">
            <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
            · {{ top.reason }}
          </ng-container>
          <ng-template #noRenewal>No contract ending soon is losing engagement.</ng-template>
        </p>
      </ng-container>
      <!-- ITP-E-302-09 (Plan ITP-P-68 D-P9): Renewals do not apply in Non-clients; the card keeps its shape and says why. -->
      <ng-template #renewalNa>
        <p class="attention-card__figure">
          <span data-testid="card-renewal-value" class="attention-card__value">—</span>
        </p>
        <p data-testid="card-renewal-na" class="attention-card__reason">No Client Manager record, so no renewal to watch.</p>
      </ng-template>
      <div class="attention-card__foot">
        <button *ngIf="scope !== 'NonClients' && kindCount('renewal') > 0" type="button" data-testid="card-renewal-show"
                class="attention-card__link" (click)="showInList('renewal')">{{ showInListText('renewal') }}</button>
      </div>
    </article>
    <article data-testid="card-dark" class="attention-card" data-tone="warning">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-moon" aria-hidden="true"></i>
        <h4 class="attention-card__title">Going dark</h4>
      </header>
      <p class="attention-card__figure">
        <span data-testid="card-dark-value" class="attention-card__value">{{ kindCount('dark') | number }}</span>
        <span *ngIf="arrUnit('dark')" data-testid="card-dark-unit" class="attention-card__unit">{{ arrUnit('dark') }}</span>
      </p>
      <p data-testid="card-dark-reason" class="attention-card__reason">
        <ng-container *ngIf="topOf('dark') as top; else noDark">
          <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
          · {{ top.reason }}
        </ng-container>
        <ng-template #noDark>Every regular user base is logging in as usual.</ng-template>
      </p>
      <div class="attention-card__foot">
        <button *ngIf="kindCount('dark') > 0" type="button" data-testid="card-dark-show" class="attention-card__link"
                (click)="showInList('dark')">{{ showInListText('dark') }}</button>
      </div>
    </article>
    <!-- ITP-E-216-06. Usage falling (Plan ITP-P-50 Q6 / Q17): the same shape as Going dark, in orange. -->
    <article data-testid="card-usage" class="attention-card" data-tone="orange">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-arrow-trend-down" aria-hidden="true"></i>
        <h4 class="attention-card__title">Usage falling</h4>
      </header>
      <p class="attention-card__figure">
        <span data-testid="card-usage-value" class="attention-card__value">{{ kindCount('usage') | number }}</span>
        <span *ngIf="arrUnit('usage')" data-testid="card-usage-unit" class="attention-card__unit">{{ arrUnit('usage') }}</span>
      </p>
      <p data-testid="card-usage-reason" class="attention-card__reason">
        <ng-container *ngIf="topOf('usage') as top; else noUsage">
          <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
          · {{ top.reason }}
        </ng-container>
        <ng-template #noUsage>No company is opening fewer projects than usual.</ng-template>
      </p>
      <div class="attention-card__foot">
        <button *ngIf="kindCount('usage') > 0" type="button" data-testid="card-usage-show" class="attention-card__link"
                (click)="showInList('usage')">{{ showInListText('usage') }}</button>
      </div>
    </article>
    <article *ngIf="!forecast" data-testid="card-spike" class="attention-card" data-tone="watch">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-chart-line-up" aria-hidden="true"></i>
        <h4 class="attention-card__title">Spend spikes</h4>
      </header>
      <p class="attention-card__figure">
        <span data-testid="card-spike-value" class="attention-card__value">{{ kindCount('spike') | number }}</span>
        <span data-testid="card-spike-unit" class="attention-card__unit">{{ usdCompact(kindMoney('spike')) }} spent</span>
      </p>
      <p data-testid="card-spike-reason" class="attention-card__reason">
        <ng-container *ngIf="topOf('spike') as top; else noSpike">
          <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
          · {{ top.reason }}
        </ng-container>
        <ng-template #noSpike>No company's XatBot spend spiked.</ng-template>
      </p>
      <div class="attention-card__foot">
        <button *ngIf="kindCount('spike') > 0" type="button" data-testid="card-spike-show" class="attention-card__link"
                (click)="showInList('spike')">{{ showInListText('spike') }}</button>
      </div>
    </article>
    <article *ngIf="forecast" data-testid="card-forecast" class="attention-card" data-tone="watch">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-sparkles" aria-hidden="true"></i>
        <h4 class="attention-card__title">{{ forecastTitle }}</h4>
      </header>
      <p class="attention-card__figure">
        <span data-testid="card-forecast-value" class="attention-card__value">{{ usdCompact(forecast.forecast) }}</span>
        <span *ngIf="forecastChange" data-testid="card-forecast-change" class="attention-card__unit">{{ forecastChange }}</span>
      </p>
      <p data-testid="card-forecast-reason" class="attention-card__reason">
        On track for {{ forecast.forecast | currency:'USD':'symbol':'1.0-0' }} ·
        <ng-container *ngIf="topOf('spike') as top; else noForecastSpike">
          <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
          {{ top.reason }}
        </ng-container>
        <ng-template #noForecastSpike>no company's spend spiked.</ng-template>
      </p>
      <div *ngIf="forecast.series?.length" data-testid="card-forecast-chart" class="attention-card__chart">
        <app-admin-dashboard-spend-bars [series]="forecast.series ?? []" [avg14]="forecast.avg14 ?? 0"
                                        [spikeToday]="forecast.spikeToday === true"></app-admin-dashboard-spend-bars>
      </div>
      <div class="attention-card__foot">
        <button *ngIf="kindCount('spike') > 0" type="button" data-testid="card-forecast-show" class="attention-card__link"
                (click)="showInList('spike')">{{ showInListText('spike') }}</button>
      </div>
    </article>
    <article *ngIf="trials" data-testid="card-trials" class="attention-card" data-tone="positive">
      <header class="attention-card__head">
        <i class="attention-card__icon fa-regular fa-seedling" aria-hidden="true"></i>
        <h4 class="attention-card__title">Likely trial conversions</h4>
      </header>
      <p class="attention-card__figure">
        <span data-testid="card-trials-value" class="attention-card__value">{{ likelyTrials.length | number }}</span>
        <span data-testid="card-trials-unit" class="attention-card__unit">of {{ trials.Total | number }} running</span>
      </p>
      <p *ngIf="!trials.Items?.length" data-testid="trials-empty" class="attention-card__reason">No trials running</p>
      <p *ngIf="trials.Items?.length" data-testid="card-trials-reason" class="attention-card__reason">
        <ng-container *ngIf="likelyTrials[0] as top; else noLikely">
          <button type="button" class="attention-card__name" (click)="selectCompany(top.companyId)">{{ top.companyName }}</button>
          · {{ top.reason }}
        </ng-container>
        <ng-template #noLikely>No running trial looks like the trials that converted.</ng-template>
      </p>
      <ul *ngIf="trials.Items?.length" class="attention-trials">
        <li *ngFor="let trial of trials.Items.slice(0, 3)" data-testid="trial-row" class="trial-row" [title]="trial.reason">
          <button type="button" class="trial-row__company attention-card__name"
                  (click)="selectCompany(trial.companyId)">{{ trial.companyName }}</button>
          <span class="trial-row__days">{{ trial.daysLeft }}d left</span>
          <span class="trial-row__rate">{{ trial.rate | percent:'1.0-0' }}</span>
          <span data-testid="confidence-chip" class="confidence-chip" [ngClass]="'confidence-' + trial.confidence">{{ trial.confidence }}</span>
        </li>
      </ul>
      <div class="attention-card__foot">
        <p *ngIf="trials.Total > 3" data-testid="trials-more" class="attention-card__more">+{{ trials.Total - 3 }} more</p>
      </div>
    </article>
  </div>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="attention-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                             body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="attention && !attention.AsOf" data-testid="attention-pending"
                             icon="fa-regular fa-hourglass-half" [title]="pendingText"></app-admin-dashboard-empty>
  <div *ngIf="attention?.AsOf" data-testid="attention-flags" class="attention-flags">
    <div class="attention-flags__bar">
      <div data-testid="attention-tabs" class="adb-segmented attention-tabs" role="radiogroup" aria-label="Show flags">
        <ng-container *ngFor="let tab of tabs">
          <button *ngIf="tab.kind !== 'renewal' || scope !== 'NonClients'" type="button" role="radio"
                  class="adb-segmented__option" [attr.data-testid]="'attention-tab-' + (tab.kind || 'all')"
                  [attr.aria-checked]="kindFilter === tab.kind" (click)="showKind(tab.kind)">
            {{ tab.label }}
            <span *ngIf="kindCount(tab.kind) > 0" class="attention-tabs__count">{{ kindCount(tab.kind) | number }}</span>
          </button>
        </ng-container>
      </div>
      <span data-testid="attention-sort" class="attention-flags__sort">
        Sorted by {{ sortByMoney ? 'money at stake' : 'tier, then money at stake' }} ·
        <button type="button" data-testid="attention-sort-toggle" class="attention-flags__sort-toggle"
                (click)="toggleSort()">{{ sortByMoney ? 'Sort by tier' : 'Sort by money' }}</button>
      </span>
    </div>
    <app-admin-dashboard-empty *ngIf="!items.length" data-testid="attention-empty"
                               icon="fa-regular fa-circle-check" [title]="emptyTitle"
                               [body]="emptyBody"></app-admin-dashboard-empty>
    <ol *ngIf="items.length" data-testid="attention-list" class="attention-list">
      <li *ngFor="let item of visibleItems; let i = index" data-testid="attention-row" class="attention-row"
          [attr.data-tier]="item.tier || 'healthy'" [class.attention-row--selected]="item.companyId === selectedCompanyId">
        <button type="button" data-testid="attention-row-hit" class="attention-row__hit"
                [attr.aria-label]="'Why ' + item.companyName + ' is flagged'" (click)="select(item)">
          <span class="attention-row__rank">{{ i + 1 }}</span>
          <span class="attention-row__tier">
            <span data-testid="tier-badge" class="adb-tier-badge" [attr.data-tier]="item.tier || 'healthy'">{{ tierLabel(item.tier) }}</span>
            <span data-testid="attention-score" class="attention-row__score" title="Health score, 0–100">{{ item.healthScore }}</span>
          </span>
          <span class="attention-row__main">
            <span class="attention-row__name">{{ item.companyName }}</span>
            <span class="attention-row__meta">
              <span *ngFor="let flag of item.flags" data-testid="flag-chip" class="flag-chip">
                <i class="fa-regular" [ngClass]="flagIcon(flag.kind)" aria-hidden="true"></i>{{ flag.label }}
              </span>
              <span *ngIf="ownerMeta(item) as owner" data-testid="attention-owner" class="attention-row__owner">{{ owner }}</span>
            </span>
            <span *ngFor="let flag of item.flags" data-testid="attention-reason" class="attention-row__reason">{{ flag.reason }}</span>
          </span>
          <span class="attention-row__money">
            <span data-testid="attention-amount" class="attention-row__amount"
                  [class.attention-row__amount--unknown]="!item.moneyKnown">{{ item.moneyKnown ? usdCompact(item.money) : 'Unknown' }}</span>
            <span data-testid="attention-money-label" class="attention-row__money-label">{{ item.moneyLabel }}</span>
          </span>
          <i class="fa-solid fa-angle-right attention-row__chev" aria-hidden="true"></i>
        </button>
        <button type="button" data-testid="attention-company-link" class="attention-row__360" title="Company 360"
                [attr.aria-label]="'Company 360 for ' + item.companyName" (click)="open360(item.companyId, $event)">
          <i class="fa-regular fa-building" aria-hidden="true"></i>
        </button>
      </li>
    </ol>
    <button *ngIf="items.length > visibleRows" type="button" data-testid="attention-show-all" class="attention-flags__more"
            (click)="toggleShowAll()">{{ showAll ? 'Show the top ' + visibleRows : 'Show all ' + (items.length | number) }}</button>
    <div *ngIf="listTotal > items.length" data-testid="attention-showing" class="attention-flags__showing">
      Showing {{ items.length | number }} of {{ listTotal | number }}
    </div>
    <div *ngIf="resolvedItems.length" data-testid="attention-resolved" class="attention-resolved">
      <button type="button" data-testid="attention-resolved-toggle" class="attention-resolved__toggle"
              [attr.aria-expanded]="resolvedOpen" (click)="toggleResolved()">
        <i class="fa-solid" [ngClass]="resolvedOpen ? 'fa-angle-down' : 'fa-angle-right'" aria-hidden="true"></i>
        Snoozed and handled · {{ resolvedCount | number }}
      </button>
      <ol *ngIf="resolvedOpen" data-testid="attention-resolved-list" class="attention-list attention-list--resolved">
        <li *ngFor="let item of resolvedItems" data-testid="attention-resolved-row" class="attention-row"
            [attr.data-tier]="item.tier || 'healthy'" [class.attention-row--selected]="item.companyId === selectedCompanyId">
          <button type="button" data-testid="attention-resolved-hit" class="attention-row__hit"
                  [attr.aria-label]="'Why ' + item.companyName + ' was flagged'" (click)="select(item)">
            <span class="attention-row__rank">
              <i data-testid="attention-resolved-icon" class="fa-regular" [ngClass]="resolvedIcon(item)" aria-hidden="true"></i>
            </span>
            <span class="attention-row__tier">
              <span data-testid="attention-resolved-tier" class="adb-tier-badge" [attr.data-tier]="item.tier || 'healthy'">{{ tierLabel(item.tier) }}</span>
              <span data-testid="attention-resolved-score" class="attention-row__score" title="Health score, 0–100">{{ item.healthScore }}</span>
            </span>
            <span class="attention-row__main">
              <span data-testid="attention-resolved-name" class="attention-row__name">{{ item.companyName }}</span>
              <span *ngIf="ownerMeta(item) as owner" class="attention-row__meta"><span data-testid="attention-resolved-owner" class="attention-row__owner">{{ owner }}</span></span>
              <span data-testid="attention-resolved-state" class="attention-row__state">{{ resolvedText(item) }}</span>
            </span>
            <i class="fa-solid fa-angle-right attention-row__chev" aria-hidden="true"></i>
          </button>
        </li>
      </ol>
      <div *ngIf="resolvedOpen && !kindFilter && resolvedCount > resolvedItems.length" data-testid="attention-resolved-showing"
           class="attention-flags__showing">
        Showing {{ resolvedItems.length | number }} of {{ resolvedCount | number }}
      </div>
    </div>
  </div>
</section>
